export const FILEUPLOAD_UPLOAD_FILE_BEGIN = 'FILEUPLOAD_UPLOAD_FILE_BEGIN';
export const FILEUPLOAD_UPLOAD_FILE_SUCCESS = 'FILEUPLOAD_UPLOAD_FILE_SUCCESS';
export const FILEUPLOAD_UPLOAD_FILE_FAILURE = 'FILEUPLOAD_UPLOAD_FILE_FAILURE';
export const FILEUPLOAD_UPLOAD_FILE_DISMISS_ERROR = 'FILEUPLOAD_UPLOAD_FILE_DISMISS_ERROR';
export const FILEUPLOAD_SET_LOADING = 'FILEUPLOAD_SET_LOADING';
export const FILEUPLOAD_SET_NULL_LOADING_ERROR = 'FILEUPLOAD_SET_NULL_LOADING_ERROR';



// WEBPACK FOOTER //
// ./src/features/fileupload/redux/constants.js